import { render, staticRenderFns } from "./Createwishlist.vue?vue&type=template&id=39b51d28&"
import script from "./Createwishlist.vue?vue&type=script&lang=js&"
export * from "./Createwishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports